exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img-chooser{height:100%;width:100%;position:relative;display:flex;align-items:center;justify-content:center}.img-chooser .img-chooser-input{width:100%;position:absolute;top:0;left:0;right:0;bottom:0;opacity:0;z-index:1;font-size:0;cursor:pointer}.img-chooser-modal{z-index:300!important}", ""]);

// exports
